import React from 'react';

import styles from './styles.css';
import { IElementOffset } from '../../types/calculator';
import { DEFAULT_ELEMENT_OFFSET } from '../../constants/elementOffset';

export interface IFieldLayoutProps {
  children: React.ReactElement | null;
  offset: IElementOffset | undefined;
  testId: string;
}

export const FieldLayout: React.FC<IFieldLayoutProps> = ({ children, offset, testId }) => {
  return (
    <div
      className={styles['layout']}
      style={{ marginBottom: offset?.bottom ?? DEFAULT_ELEMENT_OFFSET.field.bottom }}
      data-testid={testId}
    >
      {children}
    </div>
  );
};

FieldLayout.displayName = 'FieldLayout';
